"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _superagent = _interopRequireDefault(require("superagent"));
var _api = _interopRequireDefault(require("./api"));
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var EVALUATE_MEANINGS_TIMEOUT = 120000;
var WordStore = /*#__PURE__*/function (_RootStore) {
  function WordStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, WordStore);
    _this = _callSuper(this, WordStore);
    _this.config = {
      model: _models.Word,
      deserialize: true,
      GET: {
        index: '/words',
        show: '/words/:wordId',
        forSentence: '/sentences/:sentenceId/words',
        exportIndex: '/words_export',
        associationMeaningsRetry: '/words/:wordId/association_meanings_retry'
      },
      PUT: {
        update: '/words/:wordId',
        assignPrefix: '/words/:wordId/assign_prefix',
        createPlural: '/words/:wordId/create_plural',
        removePlural: '/words/:wordId/remove_plural',
        mergeDuplicateWords: '/words/:wordId/merge_duplicate_words',
        createDuplicateTarget: '/words/:wordId/create_duplicate_target',
        clearVerbConjugations: '/words/:wordId/clear_verb_conjugations',
        createEmptyVerbConjugations: '/words/:wordId/create_empty_verb_conjugations',
        createVerbConjugations: '/words/:wordId/create_verb_conjugations',
        searchByParams: '/words/search_by_params',
        updateFalseMultipleChoiceOptions: '/words/:wordId/update_false_multiple_choice_options'
      },
      POST: {
        create: '/words',
        batchCreate: '/words/batch_create',
        evaluateMeanings: '/words/:wordId/evaluate_meanings',
        regenerateMeanings: '/words/:wordId/regenerate_meanings',
        retryAssociationMeanings: '/words/:wordId/retry_association_meanings'
      },
      DELETE: {
        destroy: '/words/:wordId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(WordStore, _RootStore);
  return (0, _createClass2["default"])(WordStore, [{
    key: "getForSentence",
    value: function getForSentence(sentenceId) {
      this.api({
        ids: {
          sentenceId: sentenceId
        }
      }, this.afterGetIndex.bind(this), 'GET', 'forSentence');
    }
  }, {
    key: "searchByParams",
    value: function searchByParams(params, callback) {
      this.api(params, callback, 'PUT', 'searchByParams');
    }
  }, {
    key: "assignPrefix",
    value: function assignPrefix(params, callback) {
      this.api(params, callback, 'PUT', 'assignPrefix');
    }
  }, {
    key: "createPlural",
    value: function createPlural(params, callback) {
      this.api(params, callback, 'PUT', 'createPlural');
    }
  }, {
    key: "removePlural",
    value: function removePlural(params, callback) {
      this.api(params, callback, 'PUT', 'removePlural');
    }
  }, {
    key: "mergeDuplicateWords",
    value: function mergeDuplicateWords(params, callback) {
      this.api(params, callback, 'PUT', 'mergeDuplicateWords');
    }
  }, {
    key: "createDuplicateTarget",
    value: function createDuplicateTarget(params, callback) {
      this.api(params, callback, 'PUT', 'createDuplicateTarget');
    }
  }, {
    key: "clearVerbConjugations",
    value: function clearVerbConjugations(params, callback) {
      this.api(params, callback, 'PUT', 'clearVerbConjugations');
    }
  }, {
    key: "createEmptyVerbConjugations",
    value: function createEmptyVerbConjugations(params, callback) {
      this.api(params, callback, 'PUT', 'createEmptyVerbConjugations');
    }
  }, {
    key: "createVerbConjugations",
    value: function createVerbConjugations(params, callback) {
      this.api(params, callback, 'PUT', 'createVerbConjugations');
    }
  }, {
    key: "updateFalseMultipleChoiceOptions",
    value: function updateFalseMultipleChoiceOptions(params, callback) {
      this.api(params, callback, 'PUT', 'updateFalseMultipleChoiceOptions');
    }
  }, {
    key: "batchCreate",
    value: function batchCreate(params, callback) {
      this.api(params, callback, 'POST', 'batchCreate');
    }
  }, {
    key: "evaluateMeanings",
    value: function evaluateMeanings(params, callback) {
      var _this2 = this;
      this.requestCounter += 1;
      this.showLoadingIcon = true;
      var url = new _models.UrlBuilder(this.config).buildFromUrls('POST', 'evaluateMeanings', params.ids);
      var requestFinalized = false;
      var finalizeRequest = function finalizeRequest() {
        if (requestFinalized) return;
        requestFinalized = true;
        _this2.afterRequestRecieved();
      };
      var onFailure = params.failureCallback || this.onFailure;
      var request = _superagent["default"].post(url).timeout(params.timeout || EVALUATE_MEANINGS_TIMEOUT).send(_api["default"].toUnderscore({
        data: params.data
      })).type('json');
      request.set('X-CSRF-Token', _api["default"].csrfToken);
      request.set('DEVICE', _api["default"].nativeDevice || 'web');
      request.on('error', params.onRequestError || onFailure);
      request.on('abort', finalizeRequest);
      request.end(function (_, res) {
        finalizeRequest();
        if (!res) {
          return;
        }
        var resp;
        try {
          resp = _api["default"].toCamel(JSON.parse(res.text));
        } catch (_unused) {
          onFailure({
            error: 'Failed to parse evaluate meanings response.'
          });
          return;
        }
        if (resp.failure && resp.message) {
          onFailure(resp);
        } else {
          callback && callback(resp);
        }
      });
    }
  }, {
    key: "retryAssociationMeanings",
    value: function retryAssociationMeanings(params, callback) {
      this.api(params, callback, 'POST', 'retryAssociationMeanings');
    }
  }, {
    key: "associationMeaningsRetry",
    value: function associationMeaningsRetry(params, callback) {
      this.api(params, callback, 'GET', 'associationMeaningsRetry');
    }
  }, {
    key: "regenerateMeanings",
    value: function regenerateMeanings(params, callback) {
      this.api(params, callback, 'POST', 'regenerateMeanings');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new WordStore();